// extracted by mini-css-extract-plugin
export default {"container":"HeadToHeadCard_container__ZYW3U"};